import { useState, useContext, useEffect } from "react";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import { alertContext } from "../contexts/AlertProvider";
import Alert from "../Alert";
import PermissionGate from "../layout/PermissionGate";
import BillingAddress from "../layout/BillingAddress";
import LegalAddress from "../layout/LegalAddress";
import DriverPricingSelect from "../layout/DriverPricingSelect";
import CompanyPricingSelect from "../layout/CompanyPricingSelect";

const EditDelivaryCompany = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStep, setLoadingStep] = useState("");
  const { id } = useParams();
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");

  const processData = (type, event, field) => {
    if (type === "text") {
      const value = event.target.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "select") {
      const value = event?.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "date") {
      const value = moment(event).format("DD-MM-YYYY");
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "file") {
      setLoadingStep(field);
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64 = reader.result.split(",")[1];
          const extensionMatch = file.name.match(/\.([^.]+)$/);
          const extension = extensionMatch[1].toLowerCase();
          const fileName = file.name;
          const fileObject = {
            type: extension,
            content: base64,
            fileName: fileName,
          };
          axios
            .post(
              process.env.REACT_APP_API_ENDPOINT + "upload-file",
              {
                file: fileObject,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            )
            .then((res) => {
              const newData = { ...data };
              newData[field] = res.data.data;
              const newError = { ...error };
              newError[field] = "";
              delete newError[field];
              setData({ ...newData });
              setError({ ...newError });
              setLoadingStep("");
            })
            .catch((error) => {
              console.error(error);
            });
        };
        reader.readAsDataURL(file);
      }
    }
    if (type === "checkbox") {
      const value = event;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "currency") {
      const value = event;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
  };
  const editCompany = () => {
    const errors = {};
    if (data.name === undefined || data.name === "") {
      errors["name"] = "Please enter name";
    }
    if (data.legalName === undefined || data.legalName === "") {
      errors["legalName"] = "Please enter legal name";
    }
    if (data.revenueSharing === undefined || data.revenueSharing === "") {
      errors["revenueSharing"] = "Please enter revenue sharing";
    }
    if (data.defaultCurrency === undefined || data.defaultCurrency === "") {
      errors["defaultCurrency"] = "Please select default currency";
    }
    if (data.logo === undefined || data.logo === "") {
      errors["logo"] = "Please upload logo";
    }
    if (data.licenceExpiary === undefined || data.licenceExpiary === "") {
      errors["licenceExpiary"] = "Please select licence expiary";
    }
    if (data.licencePhoto === undefined || data.licencePhoto === "") {
      errors["licencePhoto"] = "Please upload licence photo";
    }
    if (data.contractPhoto === undefined || data.contractPhoto === "") {
      errors["contractPhoto"] = "Please upload contract photo";
    }
    if (data.signatoryDocument === undefined || data.signatoryDocument === "") {
      errors["signatoryDocument"] = "Please upload signatory document";
    }
    if (
      data.articlesOfAssociation === undefined ||
      data.articlesOfAssociation === ""
    ) {
      errors["articlesOfAssociation"] = "Please upload articles of association";
    }
    if (
      data.billingArea === undefined ||
      data.billingArea === "" ||
      data.billingArea === null
    ) {
      errors["billingArea"] = "Please select billing area";
    }
    if (
      data.billingBlock === undefined ||
      data.billingBlock === "" ||
      data.billingBlock === null
    ) {
      errors["billingBlock"] = "Please select billing block";
    }
    if (
      data.billingStreet === undefined ||
      data.billingStreet === "" ||
      data.billingStreet === null
    ) {
      errors["billingStreet"] = "Please select billing street";
    }
    if (
      data.billingBuildingNoOrName === undefined ||
      data.billingBuildingNoOrName === ""
    ) {
      errors["billingBuildingNoOrName"] = "Please enter building no";
    }
    if (data.billingJadda === undefined || data.billingJadda === "") {
      errors["billingJadda"] = "Please enter billing jadda";
    }
    if (
      data.billingApartmentOrOffice === undefined ||
      data.billingApartmentOrOffice === ""
    ) {
      errors["billingApartmentOrOffice"] = "Please enter apartment name";
    }
    if (data.billingFloor === undefined || data.billingFloor === "") {
      errors["billingFloor"] = "Please enter billing floor";
    }
    if (
      data.legalArea === undefined ||
      data.legalArea === "" ||
      data.legalArea === null
    ) {
      errors["legalArea"] = "Please select legal area";
    }
    if (
      data.legalBlock === undefined ||
      data.legalBlock === "" ||
      data.legalBlock === null
    ) {
      errors["legalBlock"] = "Please select legal block";
    }
    if (
      data.legalStreet === undefined ||
      data.legalStreet === "" ||
      data.legalStreet === null
    ) {
      errors["legalStreet"] = "Please select legal street";
    }
    if (
      data.legalBuildingNoOrName === undefined ||
      data.legalBuildingNoOrName === ""
    ) {
      errors["legalBuildingNoOrName"] = "Please enter building no";
    }
    if (data.legalJadda === undefined || data.legalJadda === "") {
      errors["legalJadda"] = "Please enter legal jadda";
    }
    if (
      data.legalApartmentOrOffice === undefined ||
      data.legalApartmentOrOffice === ""
    ) {
      errors["legalApartmentOrOffice"] = "Please enter apartment name";
    }
    if (data.legalFloor === undefined || data.legalFloor === "") {
      errors["legalFloor"] = "Please enter legal floor";
    }
    if (data.notes === undefined || data.notes === "") {
      errors["notes"] = "Please enter notes";
    }

    setError({ ...errors });
    if (
      errors.name === undefined &&
      errors.legalName === undefined &&
      errors.defaultCurrency === undefined &&
      errors.logo === undefined &&
      errors.licenceExpiary === undefined &&
      errors.licencePhoto === undefined &&
      errors.contractPhoto === undefined &&
      errors.signatoryDocument === undefined &&
      errors.articlesOfAssociation === undefined &&
      errors.billingArea === undefined &&
      errors.billingBlock === undefined &&
      errors.billingStreet === undefined &&
      errors.billingBuildingNoOrName === undefined &&
      errors.billingJadda === undefined &&
      errors.billingApartmentOrOffice === undefined &&
      errors.billingFloor === undefined &&
      errors.legalArea === undefined &&
      errors.legalBlock === undefined &&
      errors.legalStreet === undefined &&
      errors.legalBuildingNoOrName === undefined &&
      errors.legalJadda === undefined &&
      errors.legalApartmentOrOffice === undefined &&
      errors.legalFloor === undefined &&
      errors.notes === undefined &&
      errors.revenueSharing === undefined
    ) {
      setIsLoading(true);
      axios
        .post(
          process.env.REACT_APP_API_ENDPOINT + "edit-delivary-company",
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          setIsLoading(false);
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
            }
          }
        })
        .catch(console.error);
    }
  };
  const fetchCompanyDetails = () => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
        `delivary-company-details?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(async (res) => {
        if (res.data.code === 1) {
          setData(res.data.data);
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  useEffect(() => {
    fetchCompanyDetails();
  }, []);
  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        legalArea: data?.billingArea ?? null,
        legalBlock: data?.billingBlock ?? null,
        legalStreet: data?.billingStreet ?? null,
        legalBuildingNoOrName: data?.billingBuildingNoOrName ?? "",
        legalJadda: data?.billingJadda ?? "",
        legalApartmentOrOffice: data?.billingApartmentOrOffice ?? "",
        legalFloor: data?.billingFloor ?? "",
      });
      setError({
        ...error,
        legalArea: "",
        legalBlock: "",
        legalStreet: "",
        legalBuildingNoOrName: "",
        legalJadda: "",
        legalApartmentOrOffice: "",
        legalFloor: "",
      });
    }
  }, [data?.billingAndLegalAddressSame]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Edit Delivery Company
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <form
                  autoComplete="off"
                  id="addNewDeliveryCompanyForm"
                  encType="multipart/form-data"
                >
                  {/* Start:Company Info */}
                  <div className="row g-5 g-lg-10 mb-5">
                    {/*begin::Card*/}
                    <PermissionGate required={`edit_delivery_company`}>
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header">
                          {/*begin::Card title*/}
                          <div className="card-title">Company Info</div>
                          {/*begin::Card title*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4">
                          <div className="row">
                            <div className="col-md-4 mb-3 fv-row">
                              <label className="form-label required">
                                Company Name
                              </label>
                              <input
                                id="name"
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Enter Company Name"
                                data-error="* Please Enter Company Name"
                                value={data?.name ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "name");
                                }}
                              />
                              {error.name !== undefined && error.name !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.name}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Legal Name
                              </label>
                              <input
                                id="legal_name"
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Enter Company Legal Name"
                                data-error="* Please Enter Company Legal Name"
                                value={data?.legalName ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "legalName");
                                }}
                              />
                              {error.legalName !== undefined &&
                                error.legalName !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.legalName}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Target Margin %
                              </label>
                              <input
                                id="revenue_sharing"
                                type="number"
                                className="form-control add-delivery-company-field"
                                placeholder="e.g. 30"
                                data-error="* Please Enter Revenue Sharing"
                                value={data?.revenueSharing ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "revenueSharing");
                                }}
                              />
                              <small className="text-muted">
                                Reporting target only. Does not affect driver
                                pay.
                              </small>
                              {error.revenueSharing !== undefined &&
                                error.revenueSharing !== "" ? (
                                <small className="text-danger mt-2 d-block">
                                  {error.revenueSharing}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <PermissionGate
                              required={`view_driver_pricing_model_list`}
                              fallback={<></>}
                              show={false}
                            >
                              <div className="col-md-4 mb-3">
                                <DriverPricingSelect
                                  value={data?.driverPricingModel}
                                  onChange={(id) => {
                                    setData({
                                      ...data,
                                      driverPricingModel: id,
                                    });
                                  }}
                                  inheritLabel="Use default"
                                />
                              </div>
                            </PermissionGate>
                            <PermissionGate
                              required={`view_company_pricing_model_list`}
                              fallback={<></>}
                              show={false}
                            >
                              <div className="col-md-4 mb-3">
                                <CompanyPricingSelect
                                  value={data?.commissionModel}
                                  onChange={(id) => {
                                    setData({
                                      ...data,
                                      commissionModel: id,
                                    });
                                  }}
                                  inheritLabel="No commission model"
                                />
                              </div>
                            </PermissionGate>
                            <div className="col-md-12 mb-3">
                              <label className="form-label required">
                                Default Currency
                              </label>
                              <div className="fv-row">
                                {/*begin::Radio group*/}
                                <div
                                  className="btn-group w-100 overflow-auto"
                                  data-kt-buttons="true"
                                  data-kt-buttons-target="[data-kt-button]"
                                >
                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "KWD"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="KWD"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "KWD",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    KWD
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "JOD"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="JOD"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "JOD",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    JOD
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "USD"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="USD"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "USD",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    USD
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "SAR"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="SAR"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "SAR",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    SAR
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "AED"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="AED"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "AED",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    AED
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "BHD"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="BHD"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "BHD",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    BHD
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "QAR"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="QAR"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "QAR",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    QAR
                                  </label>
                                  {/*end::Radio*/}

                                  {/*begin::Radio*/}
                                  <label
                                    className={
                                      data.defaultCurrency === "EGP"
                                        ? "btn btn-outline btn-md btn-active-primary btn-color-muted bg-primary text-light"
                                        : "btn btn-outline btn-md btn-active-primary btn-color-muted"
                                    }
                                  >
                                    {/*begin::Input*/}
                                    <input
                                      className="btn-check add-delivery-company-field"
                                      type="radio"
                                      value="EGP"
                                      data-error="* Select Default Currency"
                                      onClick={() => {
                                        processData(
                                          "currency",
                                          "EGP",
                                          "defaultCurrency",
                                        );
                                      }}
                                    />
                                    {/*end::Input*/}
                                    EGP
                                  </label>
                                  {/*end::Radio*/}
                                </div>
                                {/*end::Radio group*/}
                              </div>
                              {error.defaultCurrency !== undefined &&
                                error.defaultCurrency !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.defaultCurrency}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Company Logo
                              </label>
                              <input
                                id="logo"
                                type="file"
                                accept="image/*"
                                className="form-control add-delivery-company-field"
                                data-error="* Please Upload Company Logo"
                                onChange={(e) => {
                                  processData("file", e, "logo");
                                }}
                              />
                              {error.logo !== undefined && error.logo !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.logo}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "logo" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Licence Expiary
                              </label>

                              <Flatpickr
                                options={{ dateFormat: "d-m-Y" }}
                                value={data?.licenceExpiary ?? ""}
                                onChange={([licenceExpiary]) => {
                                  processData(
                                    "date",
                                    licenceExpiary,
                                    "licenceExpiary",
                                  );
                                }}
                                className="form-control"
                                placeholder="Pick date"
                              />
                              {error.licenceExpiary !== undefined &&
                                error.licenceExpiary !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.licenceExpiary}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                License Photo
                              </label>
                              <input
                                id="license_photo"
                                type="file"
                                accept="image/*"
                                className="form-control add-delivery-company-field"
                                data-error="* Please Upload Licence Photo"
                                onChange={(e) => {
                                  processData("file", e, "licencePhoto");
                                }}
                              />
                              {error.licencePhoto !== undefined &&
                                error.licencePhoto !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.licencePhoto}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "licencePhoto" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Contract Photo
                              </label>
                              <input
                                id="contract_photo"
                                type="file"
                                accept="image/*"
                                className="form-control add-delivery-company-field"
                                data-error="* Please Upload Contract Photo"
                                onChange={(e) => {
                                  processData("file", e, "contractPhoto");
                                }}
                              />
                              {error.contractPhoto !== undefined &&
                                error.contractPhoto !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.contractPhoto}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "contractPhoto" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Signatory Document
                              </label>
                              <input
                                id="signatory_document"
                                type="file"
                                className="form-control add-delivery-company-field"
                                data-error="* Please Upload Signatory Document"
                                onChange={(e) => {
                                  processData("file", e, "signatoryDocument");
                                }}
                              />
                              {error.signatoryDocument !== undefined &&
                                error.signatoryDocument !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.signatoryDocument}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "signatoryDocument" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-4 mb-3">
                              <label className="form-label required">
                                Articles of Association
                              </label>
                              <input
                                id="articles_of_association"
                                type="file"
                                className="form-control add-delivery-company-field"
                                data-error="* Please Upload Articles of Association"
                                onChange={(e) => {
                                  processData(
                                    "file",
                                    e,
                                    "articlesOfAssociation",
                                  );
                                }}
                              />
                              {error.articlesOfAssociation !== undefined &&
                                error.articlesOfAssociation !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.articlesOfAssociation}
                                </small>
                              ) : (
                                ""
                              )}
                              {loadingStep === "articlesOfAssociation" ? (
                                <small className="text-warning mt-2">
                                  Please Wait File Uploding...
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        <BillingAddress
                          data={data}
                          processData={processData}
                          error={error}
                          setData={setData}
                          setError={setError}
                          column={2}
                        />
                        <LegalAddress
                          data={data}
                          processData={processData}
                          error={error}
                          setData={setData}
                          setError={setError}
                          column={2}
                        />
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12 mb-5 mt-3">
                              <div className="form-check form-check-custom">
                                <input
                                  className="form-check-input me-3"
                                  type="checkbox"
                                  checked={
                                    data?.billingAndLegalAddressSame ?? false
                                  }
                                  onChange={() => {
                                    setData((prev) => ({
                                      ...prev,
                                      billingAndLegalAddressSame:
                                        !data.billingAndLegalAddressSame,
                                    }));
                                  }}
                                />
                                <label className="form-check-label" htmlFor="">
                                  <div className="fw-bold text-gray-800">
                                    Same Billing and Legal Address
                                  </div>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <label className="form-label required">
                                Notes/Instructions
                              </label>
                              <input
                                type="text"
                                className="form-control add-delivery-company-field"
                                placeholder="Enter Notes/Instructions"
                                data-error="* Enter Notes/Instructions"
                                value={data?.notes ?? ""}
                                onChange={(e) => {
                                  processData("text", e, "notes");
                                }}
                              />
                              {error.notes !== undefined &&
                                error.notes !== "" ? (
                                <small className="text-danger mt-2">
                                  {error.notes}
                                </small>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <button
                            type="button"
                            className="btn btn-primary me-2"
                            id="editDeliveryCompanyBtn"
                            onClick={() => {
                              editCompany();
                            }}
                          >
                            <span className="indicator-label">
                              Update Delivery Company
                            </span>
                          </button>
                        </div>
                        {/*end::Card body*/}
                      </div>
                    </PermissionGate>
                    {/*end::Card*/}
                  </div>
                  {/* End:Company Info */}
                </form>
              </div>
              {/*end::Post*/}
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default EditDelivaryCompany;
